export const legacyVoxnelaStateKey = 'voxnela:user-state:v1'

const accountStateKeyPrefix = 'voxnela:user-state:v2'

export function accountScopedStateKey(userId: string | null): string {
  return `${accountStateKeyPrefix}:${userId || 'guest'}`
}

export function readAccountScopedState(userId: string | null): string | null {
  return (
    localStorage.getItem(accountScopedStateKey(userId)) ??
    (userId ? null : localStorage.getItem(legacyVoxnelaStateKey))
  )
}
